import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { fetchFtpLogs } from 'utils/api/logsApi'
import { getColumns } from './utils'
import { AxiosError } from 'axios'
import { calculateOffset } from 'utils/helpers/pagination'
import { filterEmptyValues } from 'utils/helpers'
import { FILTER_FIELD_FTP_LOG } from './ftpLogFilterForm'

const FtpLogTable = () => {
  const [logResponse, setLogResponse] = useState<any>({})
  const [page, setPage] = useState<number>(0)

  const { search } = useLocation()
  const { getAllQueries } = useQuery()

  const columns = useMemo(() => getColumns(page), [page])

  // To get FTP Creation Log data
  const getLogs = async () => {
    try {
      const queries = getAllQueries()
      const filters = filterEmptyValues(queries[FILTER_FIELD_FTP_LOG] || {})

      const { data } = await fetchFtpLogs({
        limit: queries.limit || 10,
        page: queries.page || 1,
        filters,
      })
      setPage(calculateOffset(data))
      setLogResponse(data)
    } catch (error) {
      if (error instanceof AxiosError) {
        setLogResponse({ docs: [] })
      }
    }
  }

  useEffect(() => {
    getLogs()
  }, [search])

  return (
    <>
      <DataTable columns={columns} rows={logResponse?.docs} identifier="_id" />

      {/* Table Pagination */}
      <DataTablePagination
        currentPage={logResponse?.page}
        totalPages={logResponse?.totalPages}
        hasNextPage={logResponse?.hasNextPage}
        hasPrevPage={logResponse?.hasPrevPage}
        limit={logResponse?.limit}
        nextPage={logResponse?.nextPage}
        prevPage={logResponse?.prevPage}
      />
    </>
  )
}

export default FtpLogTable
